import { LitPopupElement } from '../custom-elements/LitPopupElement/LitPopupElement';

let videoSrc: string | null = null;
const NO_SCROLL_CLASS = 'no-scroll';

function insertIframe(container: HTMLElement, src: string) {
    const iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.className = 'vk-video-frame js-vk-player';
    iframe.setAttribute('allow', 'autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allowfullscreen', '');

    container.innerHTML = '';
    container.appendChild(iframe);
}

function removeIframe(container: HTMLElement) {
    container.innerHTML = '';
}

function onButtonClick(event: Event) {
    const button = event.currentTarget as HTMLElement;
    const link = button.getAttribute('data-video-src');

    if (!link) return;

    videoSrc = link;

    const popup = document.querySelector<LitPopupElement>('.js-video-popup');
    if (popup) {
        popup.open();
    }
}

function onPopupOpen(event: Event) {
    const popup = event.currentTarget as LitPopupElement;
    const container = popup.querySelector<HTMLElement>('.js-video-player');

    if (container && videoSrc) {
        insertIframe(container, videoSrc);
    }
}

function onPopupCloseComplete() {
    const popup = document.querySelector<LitPopupElement>('.js-video-popup');
    if (popup) {
        const container = popup.querySelector<HTMLElement>('.js-video-player');
        if (container) {
            removeIframe(container);
        }
    }
    document.documentElement.classList.remove(NO_SCROLL_CLASS);

    videoSrc = null;
}

function init() {
    const vkButtons = document.querySelectorAll<HTMLElement>('.js-vk-button');
    const popup = document.querySelector<LitPopupElement>('.js-video-popup');

    if (!popup) return;

    vkButtons.forEach((button) => {
        button.addEventListener('click', onButtonClick);
    });

    popup.addEventListener('open', onPopupOpen);
    popup.addEventListener('close-complete', onPopupCloseComplete);
}

const _module = { init };

export default _module;
